export const HeroSupportTypeEnum = {
  normal: 'normal', // normal
  card: 'card' // card
};
